import ja from 'vuetify/es5/locale/ja';  // 导入Vuetify 自带的简体中文语言包

export default {
	label: '日本語',
	// page login
	login: '登录',
	logout: 'ログアウト',
	register: '注册',
	username: '用户名',
	password: '密码',
	login_account: '登录帐户',
	// menu
	home_tabs: {
		home: 'ホーム',
		plan: 'プラン',
		task: 'タスク',
		consuling: 'カウンセリング',
		calendar: 'カレンダー',
		report: 'レポート',
		meeting: 'ミーティング予約',
		notice: '通知',
		coach: 'コーチ',
		customer: 'お客様',
	},
	msg: 'Item Text',
	...ja,
}